"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(380), ";margin-left:", (0, _util.rem)(36), ";position:relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));

var closeBtn = function closeBtn(theme) {
  return /*#__PURE__*/(0, _react.css)("position:absolute;border-radius:50%;width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";left:calc(100% + ", (0, _util.rem)(2), ");top:", (0, _util.rem)(-17), ";background-color:", theme.color.monochrome.white, ";display:flex;justify-content:center;align-items:center;cursor:pointer;box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);svg{color:", theme.color.monochrome.black, ";opacity:0.5;width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";}&:hover{svg{opacity:0.7;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:closeBtn;"));
};

var card = function card(theme) {
  return /*#__PURE__*/(0, _react.css)("overflow:auto;max-height:calc(100vh - ", (0, _util.rem)(40), ");box-shadow:0 ", (0, _util.rem)(2), " ", (0, _util.rem)(14), " 0 rgba(", theme.color.monochrome.black_rgba, ", 0.1);border-radius:", (0, _util.rem)(12), ";background-color:", theme.color.monochrome.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:card;"));
};

var imgWrapper = function imgWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.brand['50'], ";padding:", (0, _util.rem)(20), " ", (0, _util.rem)(34), ";border-top-left-radius:", (0, _util.rem)(12), ";border-top-right-radius:", (0, _util.rem)(12), ";img{width:", (0, _util.rem)(312), ";border-radius:", (0, _util.rem)(8), ";display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:imgWrapper;"));
};

var bigImgWapper = /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(461), ";margin:0 auto;border-radius:", (0, _util.rem)(8), ";img{width:100%;height:100%;border-radius:inherit;display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:bigImgWapper;"));
var content = /*#__PURE__*/(0, _react.css)("padding:", (0, _util.rem)(25), " ", (0, _util.rem)(19), " ", (0, _util.rem)(16), " ", (0, _util.rem)(27), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:content;"));

var tag = function tag(theme) {
  return /*#__PURE__*/(0, _react.css)("display:inline-block;background-color:", theme.color.brand['800'], ";border-radius:", (0, _util.rem)(200), ";padding:0 ", (0, _util.rem)(12), ";color:", theme.color.monochrome.white, ";font-size:", theme.fontSize.small, ";font-weight:", theme.fontWeight.semibold, ";text-transform:uppercase;line-height:", (0, _util.rem)(24), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:tag;"));
};

var heading = function heading(theme) {
  return /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.semibold, ";margin-top:", (0, _util.rem)(12), ";line-height:", theme.lineHeight.leadingSnug, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:heading;"));
};

var copy = function copy(theme) {
  return /*#__PURE__*/(0, _react.css)("font-size:", theme.fontSize.xlarge, ";margin:", (0, _util.rem)(8), " 0 0;line-height:1.8;" + (process.env.NODE_ENV === "production" ? "" : ";label:copy;"));
};

var bigCopy = function bigCopy(theme) {
  return /*#__PURE__*/(0, _react.css)("font-size:", theme.fontSize.x2large, ";margin:", (0, _util.rem)(4), " 0 ", (0, _util.rem)(32), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bigCopy;"));
};

var btn = function btn(theme) {
  return /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(40), ";padding-right:", (0, _util.rem)(40), ";font-size:", theme.fontSize.large, ";font-weight:", theme.fontWeight.semibold, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:btn;"));
};

var btnTertiary = function btnTertiary(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.black, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:btnTertiary;"));
};

var styles = {
  base: base,
  closeBtn: closeBtn,
  card: card,
  imgWrapper: imgWrapper,
  bigImgWapper: bigImgWapper,
  content: content,
  tag: tag,
  heading: heading,
  copy: copy,
  bigCopy: bigCopy,
  btn: btn,
  btnTertiary: btnTertiary
};
exports.styles = styles;
//# sourceMappingURL=Announcement.styles.js.map